export const BUTTON_TYPES = {
	danger: 'danger',
	primary: 'primary',
};
